import { useCallback } from 'react'
import { useShowPrompt } from 'civic-champs-shared/core/modal/hooks'
import { ConfirmDialog } from 'civic-champs-shared/core/confirm-dialog/'
import { useRemoveTag } from './useRemoveTag'
import { TagWithReporting } from '../types'

const getDeleteTagPrompt = (tag: TagWithReporting) => {
  if (tag.usedTimes > 0) {
    return {
      title: 'Are you sure you want to delete this tag?',
      text: 'Deleting this tag will permanently remove it from the system, including all cases where it is currently in use.',
    }
  }

  return {
    title: 'Are you sure you want to delete this tag?',
    text: 'Deleting this tag will permanently remove it from the system. This action cannot be undone.',
  }
}

export const useRemoveTagPrompt = (eagerRemove: any) => {
  const showPrompt = useShowPrompt(ConfirmDialog)
  const removeTag = useRemoveTag(eagerRemove)

  return useCallback(
    async (tag: TagWithReporting) => {
      const { title, text } = getDeleteTagPrompt(tag)
      const confirmed = await showPrompt({
        text,
        title,
        confirmText: 'Delete Tag',
        cancelText: 'Do Not Delete',
        type: 'warning',
      })

      if (confirmed) {
        await removeTag(tag)
      }
    },
    [showPrompt, removeTag],
  )
}

export default useRemoveTagPrompt
